import React, { useState } from 'react';
import { SearchIcon, FilterIcon, PlusIcon, ChevronLeftIcon, ChevronRightIcon, XIcon, CalendarIcon, UserIcon, DollarSignIcon } from 'lucide-react';
const LawajamManagementScreen = () => {
  const [showAddModal, setShowAddModal] = useState(false);
  const [selectedEntry, setSelectedEntry] = useState(null);
  // Sample lawajam data
  const lawajamEntries = [{
    id: 1,
    member: 'Ahmed Ali',
    itsNumber: 'ITS12345',
    amount: 2500,
    date: '2023-08-10',
    status: 'Paid',
    paymentMethod: 'Cash'
  }, {
    id: 2,
    member: 'Murtaza Husain',
    itsNumber: 'ITS23456',
    amount: 1500,
    date: '2023-08-09',
    status: 'Pending',
    paymentMethod: 'Bank Transfer'
  }, {
    id: 3,
    member: 'Yusuf Najmuddin',
    itsNumber: 'ITS34567',
    amount: 3000,
    date: '2023-08-08',
    status: 'Paid',
    paymentMethod: 'Cash'
  }, {
    id: 4,
    member: 'Taher Saifuddin',
    itsNumber: 'ITS45678',
    amount: 2000,
    date: '2023-08-07',
    status: 'Pending',
    paymentMethod: 'Check'
  }, {
    id: 5,
    member: 'Qasim Hakimuddin',
    itsNumber: 'ITS56789',
    amount: 1000,
    date: '2023-08-06',
    status: 'Paid',
    paymentMethod: 'Cash'
  }, {
    id: 6,
    member: 'Hussain Burhanuddin',
    itsNumber: 'ITS67890',
    amount: 2200,
    date: '2023-08-05',
    status: 'Paid',
    paymentMethod: 'Bank Transfer'
  }, {
    id: 7,
    member: 'Ali Akbar',
    itsNumber: 'ITS78901',
    amount: 1800,
    date: '2023-08-04',
    status: 'Pending',
    paymentMethod: 'Cash'
  }, {
    id: 8,
    member: 'Mohammed Qutbuddin',
    itsNumber: 'ITS89012',
    amount: 3500,
    date: '2023-08-03',
    status: 'Paid',
    paymentMethod: 'Check'
  }, {
    id: 9,
    member: 'Saifuddin Najam',
    itsNumber: 'ITS90123',
    amount: 1200,
    date: '2023-08-02',
    status: 'Pending',
    paymentMethod: 'Bank Transfer'
  }, {
    id: 10,
    member: 'Badruddin Qutbi',
    itsNumber: 'ITS01234',
    amount: 2800,
    date: '2023-08-01',
    status: 'Paid',
    paymentMethod: 'Cash'
  }];
  // Function to open the edit modal with selected entry
  const handleEdit = entry => {
    setSelectedEntry(entry);
    setShowAddModal(true);
  };
  // Function to open an empty add modal
  const handleAdd = () => {
    setSelectedEntry(null);
    setShowAddModal(true);
  };
  return <div className="space-y-6" data-id="element-308">
      <div className="flex justify-between items-center" data-id="element-309">
        <h1 className="text-2xl font-bold text-gray-800" data-id="element-310">Lawajam Management</h1>
        <button onClick={handleAdd} className="bg-blue-800 text-white px-4 py-2 rounded-md flex items-center" data-id="element-311">
          <PlusIcon size={18} className="mr-1" data-id="element-312" />
          Add New Entry
        </button>
      </div>
      {/* Summary Cards */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6" data-id="element-313">
        <div className="bg-white rounded-lg shadow p-6" data-id="element-314">
          <div className="text-sm font-medium text-gray-500" data-id="element-315">
            Total Collected
          </div>
          <div className="text-2xl font-bold mt-1" data-id="element-316">₹42,500</div>
          <div className="text-xs text-green-600 mt-1" data-id="element-317">+₹12,500 this month</div>
        </div>
        <div className="bg-white rounded-lg shadow p-6" data-id="element-318">
          <div className="text-sm font-medium text-gray-500" data-id="element-319">
            Pending Amount
          </div>
          <div className="text-2xl font-bold mt-1" data-id="element-320">₹6,500</div>
          <div className="text-xs text-red-600 mt-1" data-id="element-321">4 pending payments</div>
        </div>
        <div className="bg-white rounded-lg shadow p-6" data-id="element-322">
          <div className="text-sm font-medium text-gray-500" data-id="element-323">
            Average Contribution
          </div>
          <div className="text-2xl font-bold mt-1" data-id="element-324">₹2,125</div>
          <div className="text-xs text-gray-500 mt-1" data-id="element-325">Per member</div>
        </div>
        <div className="bg-white rounded-lg shadow p-6" data-id="element-326">
          <div className="text-sm font-medium text-gray-500" data-id="element-327">Total Members</div>
          <div className="text-2xl font-bold mt-1" data-id="element-328">140</div>
          <div className="text-xs text-blue-600 mt-1" data-id="element-329">
            20 pending contributions
          </div>
        </div>
      </div>
      {/* Filters */}
      <div className="bg-white p-4 rounded-lg shadow" data-id="element-330">
        <div className="flex flex-wrap gap-4 items-center" data-id="element-331">
          <div className="relative flex-grow max-w-md" data-id="element-332">
            <SearchIcon size={18} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" data-id="element-333" />
            <input type="text" placeholder="Search by member name or ITS number..." className="pl-10 pr-4 py-2 border rounded-md w-full focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-334" />
          </div>
          <button className="flex items-center space-x-1 px-3 py-2 border rounded-md hover:bg-gray-50" data-id="element-335">
            <FilterIcon size={18} data-id="element-336" />
            <span data-id="element-337">Filter</span>
          </button>
          <select className="px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-338">
            <option data-id="element-339">All Statuses</option>
            <option data-id="element-340">Paid</option>
            <option data-id="element-341">Pending</option>
          </select>
          <select className="px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-342">
            <option data-id="element-343">All Payment Methods</option>
            <option data-id="element-344">Cash</option>
            <option data-id="element-345">Bank Transfer</option>
            <option data-id="element-346">Check</option>
          </select>
          <select className="px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-347">
            <option data-id="element-348">Last 30 Days</option>
            <option data-id="element-349">This Month</option>
            <option data-id="element-350">Last Month</option>
            <option data-id="element-351">This Year</option>
          </select>
        </div>
      </div>
      {/* Table */}
      <div className="bg-white rounded-lg shadow overflow-hidden" data-id="element-352">
        <div className="overflow-x-auto" data-id="element-353">
          <table className="min-w-full divide-y divide-gray-200" data-id="element-354">
            <thead className="bg-gray-50" data-id="element-355">
              <tr data-id="element-356">
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-357">
                  Member
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-358">
                  ITS Number
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-359">
                  Amount
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-360">
                  Date
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-361">
                  Payment Method
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-362">
                  Status
                </th>
                <th scope="col" className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-363">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200" data-id="element-364">
              {lawajamEntries.map(entry => <tr key={entry.id} className="hover:bg-gray-50" data-id="element-365">
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-366">
                    <div className="flex items-center" data-id="element-367">
                      <div className="flex-shrink-0 h-10 w-10 rounded-full bg-blue-600 flex items-center justify-center text-white" data-id="element-368">
                        {entry.member.split(' ').map(n => n[0]).join('')}
                      </div>
                      <div className="ml-4" data-id="element-369">
                        <div className="text-sm font-medium text-gray-900" data-id="element-370">
                          {entry.member}
                        </div>
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-371">
                    <div className="text-sm text-gray-900" data-id="element-372">
                      {entry.itsNumber}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-373">
                    <div className="text-sm text-gray-900" data-id="element-374">
                      ₹{entry.amount.toLocaleString()}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-375">
                    <div className="text-sm text-gray-900" data-id="element-376">{entry.date}</div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-377">
                    <div className="text-sm text-gray-900" data-id="element-378">
                      {entry.paymentMethod}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-379">
                    <span className={`px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full ${entry.status === 'Paid' ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'}`} data-id="element-380">
                      {entry.status}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-381">
                    <button onClick={() => handleEdit(entry)} className="text-blue-600 hover:text-blue-900 mr-3" data-id="element-382">
                      Edit
                    </button>
                    <button className="text-red-600 hover:text-red-900" data-id="element-383">
                      Delete
                    </button>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
        <div className="bg-white px-4 py-3 flex items-center justify-between border-t" data-id="element-384">
          <div className="flex-1 flex justify-between sm:hidden" data-id="element-385">
            <button className="relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50" data-id="element-386">
              Previous
            </button>
            <button className="ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50" data-id="element-387">
              Next
            </button>
          </div>
          <div className="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between" data-id="element-388">
            <div data-id="element-389">
              <p className="text-sm text-gray-700" data-id="element-390">
                Showing <span className="font-medium" data-id="element-391">1</span> to{' '}
                <span className="font-medium" data-id="element-392">10</span> of{' '}
                <span className="font-medium" data-id="element-393">97</span> entries
              </p>
            </div>
            <div data-id="element-394">
              <nav className="relative z-0 inline-flex rounded-md shadow-sm -space-x-px" aria-label="Pagination" data-id="element-395">
                <button className="relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50" data-id="element-396">
                  <span className="sr-only" data-id="element-397">Previous</span>
                  <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" data-id="element-398" />
                </button>
                <button className="relative inline-flex items-center px-4 py-2 border border-gray-300 bg-blue-800 text-sm font-medium text-white" data-id="element-399">
                  1
                </button>
                <button className="relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50" data-id="element-400">
                  2
                </button>
                <button className="relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50" data-id="element-401">
                  3
                </button>
                <span className="relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700" data-id="element-402">
                  ...
                </span>
                <button className="relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50" data-id="element-403">
                  10
                </button>
                <button className="relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50" data-id="element-404">
                  <span className="sr-only" data-id="element-405">Next</span>
                  <ChevronRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-406" />
                </button>
              </nav>
            </div>
          </div>
        </div>
      </div>
      {/* Add/Edit Modal */}
      {showAddModal && <div className="fixed inset-0 overflow-y-auto z-50" data-id="element-407">
          <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" data-id="element-408">
            <div className="fixed inset-0 transition-opacity" aria-hidden="true" data-id="element-409">
              <div className="absolute inset-0 bg-gray-500 opacity-75" data-id="element-410"></div>
            </div>
            <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full" data-id="element-411">
              <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4" data-id="element-412">
                <div className="flex justify-between items-center pb-3 border-b" data-id="element-413">
                  <h3 className="text-lg font-medium text-gray-900" data-id="element-414">
                    {selectedEntry ? 'Edit Lawajam Entry' : 'Add New Lawajam Entry'}
                  </h3>
                  <button onClick={() => setShowAddModal(false)} className="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none" data-id="element-415">
                    <XIcon size={20} data-id="element-416" />
                  </button>
                </div>
                <div className="mt-4 space-y-4" data-id="element-417">
                  <div data-id="element-418">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-419">
                      Member
                    </label>
                    <div className="relative" data-id="element-420">
                      <UserIcon size={18} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" data-id="element-421" />
                      <select className="pl-10 pr-4 py-2 border rounded-md w-full focus:outline-none focus:ring-2 focus:ring-blue-500" defaultValue={selectedEntry?.member || ''} data-id="element-422">
                        <option value="" disabled data-id="element-423">
                          Select Member
                        </option>
                        <option data-id="element-424">Ahmed Ali</option>
                        <option data-id="element-425">Murtaza Husain</option>
                        <option data-id="element-426">Yusuf Najmuddin</option>
                        <option data-id="element-427">Taher Saifuddin</option>
                        <option data-id="element-428">Qasim Hakimuddin</option>
                        {/* More options would be here */}
                      </select>
                    </div>
                  </div>
                  <div data-id="element-429">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-430">
                      Amount (₹)
                    </label>
                    <div className="relative" data-id="element-431">
                      <DollarSignIcon size={18} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" data-id="element-432" />
                      <input type="number" className="pl-10 pr-4 py-2 border rounded-md w-full focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter amount" defaultValue={selectedEntry?.amount || ''} data-id="element-433" />
                    </div>
                  </div>
                  <div data-id="element-434">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-435">
                      Date
                    </label>
                    <div className="relative" data-id="element-436">
                      <CalendarIcon size={18} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" data-id="element-437" />
                      <input type="date" className="pl-10 pr-4 py-2 border rounded-md w-full focus:outline-none focus:ring-2 focus:ring-blue-500" defaultValue={selectedEntry?.date || new Date().toISOString().split('T')[0]} data-id="element-438" />
                    </div>
                  </div>
                  <div data-id="element-439">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-440">
                      Payment Method
                    </label>
                    <select className="px-3 py-2 border rounded-md w-full focus:outline-none focus:ring-2 focus:ring-blue-500" defaultValue={selectedEntry?.paymentMethod || ''} data-id="element-441">
                      <option value="" disabled data-id="element-442">
                        Select Payment Method
                      </option>
                      <option data-id="element-443">Cash</option>
                      <option data-id="element-444">Bank Transfer</option>
                      <option data-id="element-445">Check</option>
                    </select>
                  </div>
                  <div data-id="element-446">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-447">
                      Status
                    </label>
                    <select className="px-3 py-2 border rounded-md w-full focus:outline-none focus:ring-2 focus:ring-blue-500" defaultValue={selectedEntry?.status || 'Paid'} data-id="element-448">
                      <option data-id="element-449">Paid</option>
                      <option data-id="element-450">Pending</option>
                    </select>
                  </div>
                  <div data-id="element-451">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-452">
                      Notes (Optional)
                    </label>
                    <textarea className="px-3 py-2 border rounded-md w-full focus:outline-none focus:ring-2 focus:ring-blue-500" rows={3} placeholder="Add any additional notes here..." data-id="element-453"></textarea>
                  </div>
                </div>
              </div>
              <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse" data-id="element-454">
                <button type="button" className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-800 text-base font-medium text-white hover:bg-blue-700 focus:outline-none sm:ml-3 sm:w-auto sm:text-sm" onClick={() => setShowAddModal(false)} data-id="element-455">
                  {selectedEntry ? 'Update Entry' : 'Add Entry'}
                </button>
                <button type="button" className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none sm:mt-0 sm:w-auto sm:text-sm" onClick={() => setShowAddModal(false)} data-id="element-456">
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>}
    </div>;
};
export default LawajamManagementScreen;